import React from 'react';
import "./RetinaImage.css"

const RetinaImage = ({ smallImage, largeImage, altText}) => {
    return(
        <img className="maxWidthImage" src={smallImage} srcSet={`${largeImage} 2x`} alt={altText} />
    )
}

export default RetinaImage;